import { useRef } from 'react';
import PropTypes from 'prop-types';
import SVGChart, { formatNumber } from './svg-chart/SvgChart';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import './UsageChart.scss';

const UsageChart = (props) => {
    const { t, ready } = useTranslation();
    const { type, icon, totalScans, dailyMax, dailyAverage, data } = props;
    const svgChartWrapper = useRef(null);

    const scanDetailsItems = [
        { headline: t('Total scans'), amount: totalScans },
        { headline: t('Daily max'), amount: dailyMax },
        { headline: t('Daily average'), amount: dailyAverage },
    ];

    const scanDetailsClassname = classnames({
        scanDetailsHeadline: true
    });

    const scanDetailsItemsDOM =
        scanDetailsItems.map((item, index) => (
            <li key={index}>
                <span className={scanDetailsClassname}>
                    { item.headline }
                </span>
                <span title={item.amount}>
                    { formatNumber(item.amount) }
                </span>
            </li>
        ));

    const scanInfo = <div className="scanInfo">
        <span className="scanType"><i className={`${icon} scan-type-icon`} /> {t(type)}</span>
        <ul className="scanDetails">
            { scanDetailsItemsDOM }
        </ul>
    </div>;

    if (!ready) {
        return null;
    }

    return (
        <div className="usageChartWrapper d-flex justify-content-between">
            { scanInfo }
            <div className='svgChartWrapper' ref={svgChartWrapper}>
                <SVGChart data={data} totalScans={totalScans} dailyAverage={dailyAverage} dailyMax={dailyMax} ref={svgChartWrapper}/>
            </div>
        </div>
    );
};

UsageChart.propTypes = {
    type: PropTypes.string.isRequired,
    totalScans: PropTypes.number.isRequired,
    dailyMax: PropTypes.number.isRequired,
    dailyAverage: PropTypes.number.isRequired,
    data: PropTypes.object.isRequired,
    icon: PropTypes.string.isRequired
};

export default UsageChart;
